<template>
  <div class="add-professional-page">
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      label-width="120px"
      label-position="left"
      class="form"
    >
      <el-form-item label="头像：">
        <Upload v-model="form.avatar" :disabled="disabled" />
      </el-form-item>
      <!-- <el-form-item v-if="$showEdu" :label="`所属${$eduType}：`">
        <el-input v-model="parentName" disabled placeholder="请输入" />
      </el-form-item> -->
      <el-form-item label="邮箱：">
        <el-input
          v-model="form.email"
          placeholder="请输入"
          :disabled="disabled"
        />
      </el-form-item>
      <el-form-item label="姓名：" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入"
          :disabled="disabled"
        />
      </el-form-item>
      <el-form-item label="帐号：" prop="username">
        <el-input
          v-model="form.username"
          placeholder="请输入"
          :disabled="disabled"
        />
      </el-form-item>
      <el-form-item label="密码：" prop="password">
        <el-input
          v-model="form.password"
          placeholder="请输入"
          :disabled="disabled"
        />
      </el-form-item>
      <el-form-item label="用户状态：" prop="status">
        <el-select v-model="form.status" :disabled="disabled">
          <el-option
            v-for="item of statusOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
      </el-form-item>
      <div v-if="type === 'detail'">
        <div>机构信息：</div>
        <br />
        <el-form-item label="机构名称：">
          <el-input disabled v-model="form.businessInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话（勘误）：">
          <el-input disabled v-model="form.businessInfo.phone"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码：">
          <el-input disabled v-model="form.businessInfo.unifiedSocialCreditCode"></el-input>
        </el-form-item>
        <el-form-item label="费用返还约定：">
          <el-input
            type="textarea"
            disabled
            v-model="form.businessInfo.feeRefundAgreement"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构描述：">
          <el-input
            type="textarea"
            disabled
            v-model="form.businessInfo.businessDescribe"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <Btn
      v-if="type !== 'detail'"
      :btnText="id ? '确认修改' : '确认添加'"
      className="primary"
      style="margin-left: 250px"
      :fontSize="14"
      :width="103"
      :height="37"
      @handleClick="type === 'update' ? handleUpdate() : handCreate()"
    />
  </div>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
import Upload from "@/components/Upload";

import Btn from "../../components/Btn.vue";
import { create, info, update } from "@/api/agency";
import { educationalType } from "@/utils/mixins";
import { mapGetters } from "vuex";
export default {
  components: { Btn, UploadFile, Upload },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mixins: [educationalType],
  inject: ["$setTitle"],
  data() {
    return {
      title: "添加员工帐号",
      // id: undefined,
      // organizationId: "",
      // name: "",
      // parentName: "",
      form: {
        // enclosure: []
      },
      formRules: {
        name: [{ required: true, message: "不能为空", trigger: "change" }],
        username: [{ required: true, message: "不能为空", trigger: "change" }],
        password: [{ required: true, message: "不能为空", trigger: "change" }],
        status: [{ required: true, message: "不能为空", trigger: "change" }]
      },

      statusOptions: [
        { label: "在职", value: "1" },
        { label: "离职", value: "0" }
      ],
      disabled: true,
      type: ""
    };
  },
  created() {
    // const { id, name, parentName, organizationId } = this.$route.query;
    // this.name = name;
    // this.parentName = parentName;
    // this.organizationId = organizationId;
    // if (id) {
    //   this.title = "修改帐号信息";
    //   this.id = id;
    //   this.getInfo();
    // }
    // this.$setTitle(this.title);
    this.form.secondaryType = this.userInfo.secondaryType;

    const { id, type } = this.$route.query;
    this.type = type;
    if (this.$route.query.type !== "add") {
      this.id = id;
      if (type === "update") {
        this.disabled = false;
      }
      this.getInfo();
    } else {
      this.disabled = false;
    }
  },
  methods: {
    getInfo() {
      info({ id: this.id }).then(res => {
        console.log(res);
        this.form = res.data.d;
      });
    },
    // getInfo() {
    //   info({ id: this.id }).then(res => {
    //     const data = res.data.d;
    //     const { graduationTime } = data;
    //     if (graduationTime) {
    //       data.graduationTime = graduationTime * 1000;
    //     }
    //     this.form = data;
    //   });
    // },
    // handCreate() {
    //   this.$refs["form"].validate(valid => {
    //     if (valid) {
    //       let fun = create;
    //       if (this.id) fun = update;
    //       fun({
    //         ...this.form,
    //         // id: this.id,
    //         organizationId: this.organizationId,
    //         graduationTime: this.form.graduationTime
    //           ? this.form.graduationTime / 1000
    //           : undefined
    //       }).then(res => {
    //         this.$_message({
    //           message: this.id ? "修改成功!" : "添加成功!"
    //         });
    //         this.back();
    //       });
    //     }
    //   });
    // },
    handCreate() {
      create(this.form).then(res => {
        console.log(res);
        if (res.data.c === 200) {
          this.$message.success("创建成功");
          this.$router.back();
        }
      });
    },
    handleUpdate() {
      update(this.form).then(res => {
        if (res.data.c === 200) {
          this.$message.success("修改成功");
          this.$router.back();
        }
      });
    },
    back() {
      this.$router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/views/educational/staffDetail.vue